import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dashboard-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-nav.component.html',
  styleUrls: ['../dashboard.component.css']
})
export class DashboardNavComponent {
  @Input() activeTab: 'overview' | 'crew' | 'rooms' | 'galaxy' | 'fleet' | 'fleet-chat' | 'friends' | 'battles' | 'inventory' | 'tournament' = 'overview';
  @Input() crewCount = 0;
  @Input() roomsCount = 0;
  @Input() battlesCount = 0;
  @Input() inventoryCount = 0;
  @Input() hasGalaxy = false;
  @Input() hasAlliance = false;
  @Input() hasTournamentAnalysis = false;
  @Input() pendingFriendCount = 0;

  @Input() refreshing = false;

  @Output() tabSelect = new EventEmitter<string>();
  @Output() refreshClicked = new EventEmitter<void>();

  mobileNavOpen = false;

  get mainSection(): 'ship' | 'galaxy' | 'fleet' {
    if (['overview', 'crew', 'rooms', 'battles', 'friends', 'inventory', 'redeem'].includes(this.activeTab)) return 'ship';
    if (this.activeTab === 'galaxy') return 'galaxy';
    return 'fleet';
  }

  get activeTabLabel(): string {
    const labels: Record<string, string> = {
      overview: 'Overview', crew: 'Crew', rooms: 'Rooms',
      battles: 'Battles', friends: 'Friends', inventory: 'Inventory',
      galaxy: 'Galaxy', fleet: 'Fleet - Members', 'fleet-chat': 'Fleet - Chat',
      tournament: 'Fleet - Tournament',
    };
    return labels[this.activeTab] ?? this.activeTab;
  }

  onSelect(tab: string): void {
    this.mobileNavOpen = false;
    this.tabSelect.emit(tab);
  }
}
